import type React from 'react';
import SvgIcon from './SvgIcon';

const Plus: React.FC = () => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g id="Plus">
      <path d="M9 7.00488H16V9.00488H9V16.0049H7V9.00488H0V7.00488H7V0.00488281H9V7.00488Z" fill="currentColor" />
    </g>
  </SvgIcon>
);

export default Plus;
